import React, { useState, useEffect } from 'react';

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    padding: '0 10px',
  },
  modalContainer: {
    backgroundColor: '#fff',
    padding: '30px',
    borderRadius: '12px',
    maxWidth: '800px',
    width: '100%',
    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    fontFamily: 'Arial, sans-serif',
    overflowY: 'auto',
  },
  closeButton: {
    position: 'absolute',
    top: '15px',
    right: '15px',
    background: 'none',
    border: 'none',
    fontSize: '1.6rem',
    color: '#333',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
  },
  closeButtonHover: {
    color: '#ff4d4d',
  },
  formGroup: {
    marginBottom: '20px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: '600',
    fontSize: '1.1rem',
    color: '#333',
    minWidth: '120px',
  },
  input: {
    width: '100%',
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '1rem',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.3s ease',
  },
  inputFocus: {
    borderColor: '#007BFF',
  },
  submitButton: {
    width: '100%',
    padding: '14px',
    backgroundColor: '#007BFF',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
  },
  submitButtonHover: {
    backgroundColor: '#0056b3',
  },
  checkboxLabel: {
    fontSize: '1rem',
    color: '#555',
  },
  buttonStyle:{
    margin: '10px',
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#007BFF',
    color: '#FFFFFF',
  }
};

const EditPage = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    referenceNumber:'',
    gender: '', // Gender added here
  });
  const [country, setCountry] = useState('');
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/member/getCountryList');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (Array.isArray(data)) {
          setCountries(data);
        } else {
          console.error('Unexpected API response:', data);
          setCountries([]);
        }
      } catch (error) {
        console.error('Error fetching countries:', error);
        setCountries([]);
      }
    };
    fetchCountries();
  }, []);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const ID = localStorage.getItem('userID');


  //dob func

  const [dob, setDob] = useState('');
    const [dobTime, setDobTime] = useState('');
    const [chineseDob, setChineseDob] = useState('')
    const [chineseDobTime, setChineseDobTime] = useState('')
    const [age, setAge] = useState ('')
    const [isDobTimeUnknown, setIsDobTimeUnknown] = useState(false)
  
      const dobandtime = `${dob} ${dobTime}`;
      const cdob = `${chineseDob} ${chineseDobTime}`;
  
    const calculateAge = (dateOfBirth) => {
      const birthDate = new Date(dateOfBirth);
      const currentDate = new Date();
      
      let age = currentDate.getFullYear() - birthDate.getFullYear();
      const monthDifference = currentDate.getMonth() - birthDate.getMonth();
      
      if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())) {
        age--;
      }
      
      setAge(age); // Update the age state
    };
  
  const handleDobTimeChange = (event) => {
    const timeValue = event.target.value || '00:00';
    const formattedTime = `${timeValue}:00`;
  
    setChineseDobTime(formattedTime); // Update Chinese DOB time
    setDobTime(formattedTime);       // Sync DOB time with Chinese DOB time
  
    if (!isDobTimeUnknown) {
      handleFetchData(false); // Fetch DOB based on Chinese DOB
    }
  };
  
  const handleChineseDobTimeChange = (event) => {
    const timeValue = event.target.value || '00:00';
    const formattedTime = `${timeValue}:00`;
  
    setChineseDobTime(formattedTime); // Update Chinese DOB time
    setDobTime(formattedTime);       // Sync DOB time with Chinese DOB time
  
    if (!isDobTimeUnknown) {
      handleFetchData(true); // Fetch DOB based on Chinese DOB
    }
  };
  
  useEffect(() => {
    if (isDobTimeUnknown) {
      if (dob) {
        handleFetchData(false); // Fetch Chinese DOB based on DOB
      } else if (chineseDob) {
        handleFetchData(true); // Fetch DOB based on Chinese DOB
      }
    }
  }, [isDobTimeUnknown, dob, chineseDob]);
  
  const handleUnknownChange = (e) => {
    const isChecked = e.target.checked;
    setIsDobTimeUnknown(isChecked);
  
    if (isChecked) {
      setDobTime("00:00");
      setChineseDobTime("00:00");
    }
  };
  
  const handleFetchData = async (isChinese = false) => {
    const baseUrl = 'https://xianhefairy.com/LotusFairy_API/api/member';
    const endpoint = isChinese ? 'GetDOB_By_Lunar' : 'GetChineseDOB';
    const date = isChinese ? chineseDob : dob;
    const time = isChinese ? chineseDobTime : dobTime;
  
    // Extract date components
    const dateParts = date.split('-');
    const cYear = dateParts[0];
    const cMonth = dateParts[1];
    const cDay = dateParts[2];
    const formattedTime = time ? time.slice(0, 5) : '00:00';
  
    try {
      const response = await fetch(`${baseUrl}/${endpoint}?cYear=${cYear}&cMonth=${cMonth}&cDay=${cDay}&cTime=${formattedTime}`);
      const data = await response.json();
  
      console.log('API response:', data);
  
      if (Array.isArray(data) && data.length > 0) {
        const responseData = data[0];
  
        if (isChinese) {
          setDob(responseData.DOB.split('T')[0]); // Ensure only the date is set
          // setDobTime(responseData.DOB.split('T')[1] || '00:00'); // Extract time or default to 00:00
          console.log('DOB set from Chinese DOB:', responseData.DOB);
        } else {
          setChineseDob(responseData.LUNAR_DATE.split('T')[0]); // Ensure only the date is set
          // setChineseDobTime(responseData.LUNAR_DATE.split('T')[1] || '00:00'); // Extract time or default to 00:00
          console.log('Chinese DOB set from DOB:', responseData.LUNAR_DATE);
        }
      } else {
        console.error('Unexpected data format or empty response:', data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // const submit = () => {
  //   const {
  //       firstName,
  //       lastName,
  //       email,
  //       password,
  //       gender,
  //       referenceNumber,
  //       mobileNumber
  //     } = formData;

  //     const dobandtime = `${dob} ${dobTime}`;
  //     const cdob = `${chineseDob} ${chineseDobTime}`;

  //     const body = {
  //       ID: ID,
  //       RefNo: referenceNumber,
  //       FName: firstName,
  //       LName: lastName,
  //       DateOfBirth: dobandtime,
  //       ChineseDateOfBirth: cdob,
  //       Gender: gender,
  //       Country:country,
  //       MobileNo:mobileNumber,
  //       Age: age,
  //       Email: email,
  //       Password: password,
  //     }
  //   console.log(body)
  // }

  const submit = async () => {
    const {
      firstName,
      lastName,
      email,
      password,
      gender,
      referenceNumber,
      mobileNumber
    } = formData;

    const dobandtime = `${dob} ${dobTime}`;
    const cdob = `${chineseDob} ${chineseDobTime}`;

    const body = {
      ID: ID,
      RefNo: referenceNumber,
      FName: firstName,
      LName: lastName,
      DateOfBirth: dobandtime,
      ChineseDateOfBirth: cdob,
      Gender: gender,
      Country:country,
      MobileNo:mobileNumber,
      Age: age,
      Email: email,
      Password: "",
      Search_Interest:""
    }

    try {
      const response = await fetch(
        'https://xianhefairy.com/LotusFairy_API/api/user/ProfileSaveUpdate?token=xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json', 
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        throw new Error('Request failed with status ' + response.status);
      }
      const result = await response.json();
      console.log('Success:', result);
      alert('Profile updated successfully!');
    } catch (error) {
      console.error('Error during submission:', error);
      alert('An error occurred during submission. Please try again.');
    }
    console.log(body)
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContainer}>
        <button 
          style={{ ...styles.closeButton, ...styles.closeButtonHover }} 
          onClick={onClose}
          onMouseOver={(e) => e.target.style.color = '#ff4d4d'}
          onMouseOut={(e) => e.target.style.color = '#333'}
        >
          ×
        </button>
        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Edit Page</h2>
        <form>
          <div style={styles.formGroup}>
            <div style={{ flex: '1 1 48%' }}>
              <label htmlFor="firstName" style={styles.label}>First Name</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                style={styles.input}
              />
            </div>
            <div style={{ flex: '1 1 48%' }}>
              <label htmlFor="lastName" style={styles.label}>Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.formGroup}>
            <div style={{ flex: '1 1 48%' }}>
              <label htmlFor="email" style={styles.label}>Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={styles.input}
              />
            </div>
            <div style={{ flex: '1 1 48%' }}>
              <label htmlFor="password" style={styles.label}>Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                style={styles.input}
              />
            </div>
          </div>
          
          <div style={styles.formGroup}>
          <div style={{ flex: '1 1 48%' }}>
              <label htmlFor="mobileNumber" style={styles.label}>Mobile Number</label>
              <input
                type="text"
                id="mobileNumber"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                style={styles.input}
              />
            </div>
            <div style={{ flex: '1 1 48%' }}>
              <label htmlFor="referenceNumber" style={styles.label}>Reference Number</label>
              <input
                type="text"
                id="referenceNumber"
                name="referenceNumber"
                value={formData.referenceNumber}
                onChange={handleChange}
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.formGroup}>
          
          <div style={{ flex: '1 1 48%' }}>
              <label htmlFor="country" style={styles.label}>Country</label>
              <select
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                style={styles.input}
              >
                <option value="">Select your country</option>
                {countries.map((country) => (
                    <option key={country.ID} value={country.ID}>
                      {country.DESC_ENG}
                    </option>
                  ))}
              </select>
            </div>

            <div style={{ flex: '1 1 48%' }}>
              <label htmlFor="gender" style={styles.label}>Gender</label>
              <select
                id="gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                style={styles.input}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
          </div>

          {/* dob  */} 
{/* Date and Time of Birth Section */}
<div style={styles.formGroup}>
  <div style={{ flex: '1 1 48%' }}>
    <label htmlFor="dob" style={styles.label}>Date of Birth</label>
    <input
      type="date"
      value={dob}
      onChange={(e) => {
        setDob(e.target.value);
        calculateAge(e.target.value); // Calculate age when DOB is set
        if (isDobTimeUnknown) {
          // Set time to 00:00 if "I don't know the time" is checked
          setDobTime("00:00");
        }
      }}
      style={styles.input}
    />
    {/* Only show time input if DOB is set and isDobTimeUnknown is not checked */}
    {dob && !isDobTimeUnknown && (
      <input
        type="time"
        value={dobTime}
        onChange={handleDobTimeChange}
        style={styles.input}
      />
    )}
  </div>
  <div style={{ flex: '1 1 48%' }}>
    <label htmlFor="chineseDob" style={styles.label}>Chinese Date of Birth</label>
    <input
      type="date"
      value={chineseDob}
      onChange={(e) => {
        setChineseDob(e.target.value);
        calculateAge(e.target.value); // Calculate age when Chinese DOB is set
        if (isDobTimeUnknown) {
          // Set time to 00:00 if "I don't know the time" is checked
          setChineseDobTime("00:00");
        }
      }}
      style={styles.input}
    />
    {/* Only show time input if Chinese DOB is set and isDobTimeUnknown is not checked */}
    {chineseDob && !isDobTimeUnknown && (
      <input
        type="time"
        value={chineseDobTime}
        onChange={handleChineseDobTimeChange}
        style={styles.input}
      />
    )}
  </div>
</div>



          <div style={styles.formGroup}>
          <div style={{ flex: '1 1 48%' }}>
            <input
              type="checkbox"
              checked={isDobTimeUnknown}
              onChange={() => {
                setIsDobTimeUnknown(!isDobTimeUnknown);
                // Automatically set time to 00:00 when checkbox is checked
                if (!isDobTimeUnknown) {
                  setDobTime("00:00");
                  setChineseDobTime("00:00");
                }
              }}
              style={styles.checkboxLabelS}
            />
            <label style={styles.checkboxLabelStyle}>I don't know the time</label>
          </div>
          <div style={{ flex: '1 1 48%' }}>
            {age && (
              <div style={{ marginTop: '10px' }}>
                <p>Your Age: {age}</p>
              </div>
            )}
          </div>
          </div>

          <button
            type="button"
            onClick={submit}
            style={{ ...styles.submitButton, ...styles.submitButtonHover }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#007BFF'}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditPage;
